import type { AuthTokens } from '@brightlocal/api-client';

import { getAccessToken, setAccessToken, clearAccessToken } from './manageAccessToken';

/** Persist access token in memory. */
export const saveJWT = (tokens: AuthTokens) => {
  setAccessToken(tokens.accessToken);
};

/**
 * Returns the access token or null.
 * Returns null after a page reload because the access token is memory-only.
 */
export const getJWT = () => {
  const accessToken = getAccessToken();

  return accessToken ? { accessToken } : null;
};

/** Clear access token from memory. */
export const clearJWT = () => {
  clearAccessToken();
};
